import { AnfrageDisplayModel, GlobalEnumsAceTypphase } from "@/api/model-index";
import { AnfrageService } from "@/api/services/anfrage.service";
import { AnfrageContract } from "@/core/models/abstractions/anfrage.contract";
import { I18nService } from "@/core/services/i18nService";
import { PortalContextService } from "@/core/services/portal-context.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { NotificationService } from "@progress/kendo-angular-notification";
import { map } from "rxjs/internal/operators/map";

@Injectable({
    providedIn: 'root'
})
export class AnfrageGuard implements CanActivate {
    protected instance: AnfrageContract | null;

    constructor(protected readonly router: Router, protected readonly portalContextService: PortalContextService, protected readonly anfrageService: AnfrageService, protected notificationService: NotificationService, protected langService: I18nService) {
        //
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        await this.getAnfrage(route, state);


        if (!this.portalContextService.CurrentAnfrage?.phase?.typ || this.portalContextService.CurrentAnfrage?.phase?.typ == GlobalEnumsAceTypphase.Standard) {
            let url: string = state.url;
            let urlParts: string[] = url.split("/");

            if (urlParts[2] == "detail") {
                if (!urlParts[5] && !urlParts[6])
                    return Promise.resolve(true);
                if (this.portalContextService.CurrentAnfrage.phase?.abschnitte?.find(x => x.id == urlParts[6])
                    || this.portalContextService.CurrentAnfrage.phase?.abschnitte?.flatMap(x => x.abschnitte).find(x => x && x.id == urlParts[6]))
                    return Promise.resolve(true);
            }
        }
        this.notificationService.show({
            hideAfter: 5000,
            content: this.langService.instant("anfrage.anfrage-guard.error"),
            animation: { type: "fade", duration: 500 },
            position: { horizontal: "center", vertical: "bottom" },
            type: { style: "error", icon: true },
        });

        this.router.navigate(['/anfrage/overview']);
        return Promise.resolve(false);
    }

    getAnfrage(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<AnfrageDisplayModel | undefined> {
        return this.anfrageService.apiAnfrageAnfrageIdGet({ anfrageId: this.portalContextService.CurrentItemContext.id }).pipe(map(response => {
            if (response) {
                this.portalContextService.CurrentAnfrage = response;

                if (this.portalContextService.CurrentAnfrage)
                    return this.portalContextService.CurrentAnfrage;
            }

            return undefined;
        })).toPromise();
    }
}